/* assets/premium-product.js */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const pdpSection = document.querySelector('.premium-pdp-section');
    if (!pdpSection) return;

    // Element References
    const mainImage = document.getElementById('PdpMainImage');
    const mainMediaWrap = document.getElementById('PdpMainMediaWrap');
    const lampGlow = document.getElementById('PdpLampGlow');
    const thumbnails = document.querySelectorAll('.pdp-thumb-item');
    const prevNav = document.getElementById('PdpGalleryPrev');
    const nextNav = document.getElementById('PdpGalleryNext');
    const variantInputs = document.querySelectorAll('.pdp-variant-input');
    const masterSelect = document.getElementById('PdpMasterSelect');
    const priceCurrent = document.getElementById('PdpPriceCurrent');
    const priceCompare = document.getElementById('PdpPriceCompare');
    const discountBadge = document.getElementById('PdpDiscountBadge');
    const atcBtn = document.getElementById('PdpAtcBtn');
    const buyBtn = document.getElementById('PdpBuyBtn');
    const atcText = document.getElementById('PdpAtcText');
    const qtyInput = document.getElementById('PdpQuantity');
    const qtyMinus = document.getElementById('PdpQtyMinus');
    const qtyPlus = document.getElementById('PdpQtyPlus');
    const shareBtn = document.getElementById('PdpShareBtn');
    const tabBtns = document.querySelectorAll('.pdp-tab-btn');
    const tabPanels = document.querySelectorAll('.pdp-tab-content-panel');

    // Variant Data JSON parsing
    let variantsData = [];
    try {
      const jsonEl = document.getElementById('PdpVariantsJson');
      if (jsonEl) {
        variantsData = JSON.parse(jsonEl.textContent) || [];
      }
    } catch(e) {}

    // Variant Color Glow Map
    const glowColorMap = {
      'cyan': 'rgba(0, 245, 255, 0.4)',
      'blue': 'rgba(77, 124, 254, 0.45)',
      'purple': 'rgba(138, 46, 255, 0.45)',
      'pink': 'rgba(255, 79, 216, 0.45)',
      'green': 'rgba(0, 245, 160, 0.45)',
      'red': 'rgba(255, 60, 60, 0.45)',
      'orange': 'rgba(255, 140, 0, 0.45)',
      'yellow': 'rgba(255, 215, 0, 0.45)',
      'warm white': 'rgba(255, 220, 150, 0.45)',
      'white': 'rgba(255, 255, 255, 0.35)'
    };

    function updateLampGlowColor(colorName) {
      if (!lampGlow) return;
      const lower = (colorName || '').toLowerCase().trim();
      let matchedGlow = 'rgba(0, 245, 255, 0.3)';
      for (const [key, val] of Object.entries(glowColorMap)) {
        if (lower.includes(key)) {
          matchedGlow = val;
          break;
        }
      }
      document.documentElement.style.setProperty('--variant-glow-color', matchedGlow);
      if (mainImage) {
        mainImage.classList.add('is-glowing');
      }
    }

    // Media Gallery Logic
    let currentMediaIndex = 0;
    const mediaCount = thumbnails.length;

    function setActiveMedia(index) {
      if (mediaCount === 0) return;
      if (index >= mediaCount) index = 0;
      if (index < 0) index = mediaCount - 1;

      currentMediaIndex = index;
      const targetThumb = thumbnails[currentMediaIndex];

      if (targetThumb && mainImage) {
        const newSrc = targetThumb.dataset.src;
        if (newSrc) {
          mainImage.removeAttribute('srcset');
          mainImage.src = newSrc;
        }
        thumbnails.forEach(t => t.classList.remove('active'));
        targetThumb.classList.add('active');
        targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => setActiveMedia(idx));
    });

    if (prevNav) prevNav.addEventListener('click', () => setActiveMedia(currentMediaIndex - 1));
    if (nextNav) nextNav.addEventListener('click', () => setActiveMedia(currentMediaIndex + 1));

    // Keyboard Navigation for Media
    document.addEventListener('keydown', (e) => {
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') return;
      if (e.key === 'ArrowLeft') setActiveMedia(currentMediaIndex - 1);
      if (e.key === 'ArrowRight') setActiveMedia(currentMediaIndex + 1);
    });

    // Image Zoom on Mousemove & Double Click
    if (mainMediaWrap && mainImage) {
      mainMediaWrap.addEventListener('mousemove', (e) => {
        const { left, top, width, height } = mainMediaWrap.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        mainImage.style.transformOrigin = `${x}% ${y}%`;
        mainImage.style.transform = 'scale(1.8)';
      });

      mainMediaWrap.addEventListener('mouseleave', () => {
        mainImage.style.transformOrigin = 'center center';
        mainImage.style.transform = 'scale(1)';
      });

      mainMediaWrap.addEventListener('dblclick', () => {
        if (mainImage.requestFullscreen) {
          mainImage.requestFullscreen();
        }
      });
    }

    // Variant Selection Matching
    if (variantInputs.length > 0) {
      variantInputs.forEach(input => {
        input.addEventListener('change', () => {
          // UI selection toggle
          const parentGroup = input.closest('.pdp-variant-options, .pdp-variant-options-list');
          if (parentGroup) {
            parentGroup.querySelectorAll('.pdp-pill-btn, .pdp-swatch-btn, .pdp-size-pill, .pdp-color-swatch-item').forEach(btn => btn.classList.remove('selected'));
            input.parentElement.classList.add('selected');
          }

          // Gather selected values
          const selectedVals = [];
          document.querySelectorAll('.pdp-variant-input:checked').forEach(i => selectedVals.push(i.value.trim()));

          // Match variant
          const matchedVariant = variantsData.find(v => {
            if (!v.options) return false;
            return selectedVals.every((val, idx) => v.options[idx] === val || selectedVals.includes(v.options[idx]));
          });

          if (matchedVariant) {
            if (masterSelect) masterSelect.value = matchedVariant.id;

            // Money format
            const formatMoney = (cents) => '₹' + (cents/100).toLocaleString('en-IN', { maximumFractionDigits: 2 });

            if (priceCurrent) priceCurrent.textContent = formatMoney(matchedVariant.price);
            if (priceCompare) {
              if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                priceCompare.textContent = formatMoney(matchedVariant.compare_at_price);
                priceCompare.style.display = 'inline-block';
                if (discountBadge) {
                  const savePct = Math.round((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price * 100);
                  discountBadge.textContent = `-${savePct}% OFF`;
                  discountBadge.style.display = 'inline-block';
                }
              } else {
                priceCompare.style.display = 'none';
                if (discountBadge) discountBadge.style.display = 'none';
              }
            }

            // Image Swap
            if (matchedVariant.featured_image && mainImage) {
              mainImage.removeAttribute('srcset');
              mainImage.src = matchedVariant.featured_image;
              // Sync thumbnail
              thumbnails.forEach((t, idx) => {
                if (t.dataset.src && t.dataset.src.includes(matchedVariant.featured_image.split('?')[0])) {
                  thumbnails.forEach(x => x.classList.remove('active'));
                  t.classList.add('active');
                  currentMediaIndex = idx;
                }
              });
            }

            // Glow Sync
            updateLampGlowColor(matchedVariant.title);

            // Availability
            if (atcBtn && buyBtn) {
              if (matchedVariant.available) {
                atcBtn.disabled = false;
                buyBtn.disabled = false;
                if (atcText) atcText.textContent = 'Add to Cart';
              } else {
                atcBtn.disabled = true;
                buyBtn.disabled = true;
                if (atcText) atcText.textContent = 'Sold Out';
              }
            }
          }
        });
      });
    }

    // Quantity Counter
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', () => {
        let v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', () => {
        let v = parseInt(qtyInput.value) || 1;
        qtyInput.value = v + 1;
      });
    }

    // Vertical Tabs Switcher
    if (tabBtns.length > 0 && tabPanels.length > 0) {
      tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const targetTab = btn.dataset.tab;
          tabBtns.forEach(b => b.classList.remove('active'));
          tabPanels.forEach(p => p.classList.remove('active'));

          btn.classList.add('active');
          const activePanel = document.getElementById('PdpTab-' + targetTab);
          if (activePanel) activePanel.classList.add('active');
        });
      });
    }

    // Share Button
    if (shareBtn) {
      shareBtn.addEventListener('click', () => {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: window.location.href
          }).catch(() => {});
        } else {
          navigator.clipboard.writeText(window.location.href);
          alert('Product link copied to clipboard!');
        }
      });
    }

    // AJAX Form Add to Cart
    const atcForm = document.getElementById('PdpAddToCartForm');
    if (atcForm && atcBtn) {
      atcForm.addEventListener('submit', function(e) {
        e.preventDefault();
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Adding to Cart...';

        const formData = new FormData(atcForm);
        const data = {
          items: [{
            id: masterSelect ? masterSelect.value : formData.get('id'),
            quantity: qtyInput ? qtyInput.value : 1
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(r => r.json())
        .then(() => {
          if (atcText) atcText.textContent = '✓ Added to Cart';
          setTimeout(() => {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = 'Add to Cart';
          }, 2000);
        })
        .catch(() => {
          atcBtn.disabled = false;
          if (atcText) atcText.textContent = 'Add to Cart';
        });
      });
    }

    // Direct Buy Now Link
    if (buyBtn && masterSelect) {
      buyBtn.addEventListener('click', () => {
        const vId = masterSelect.value;
        const qVal = qtyInput ? qtyInput.value : 1;
        window.location.href = `/cart/${vId}:${qVal}`;
      });
    }

    // Dynamic Reviews & Interactive Rating Picker
    const starPicker = document.getElementById('PdpStarPicker');
    const ratingInput = document.getElementById('pdpReviewRatingInput');
    const reviewForm = document.getElementById('pdpSubmitReviewForm');
    const reviewsContainer = document.getElementById('pdpReviewsContainer');
    const tabBtnReviews = document.getElementById('PdpTabBtnReviews');

    const productId = pdpSection.getAttribute('data-product-id') || window.location.pathname;
    const storageKey = 'pdp_reviews_' + productId;

    let selectedRating = 5;

    if (starPicker && ratingInput) {
      const stars = starPicker.querySelectorAll('span');
      stars.forEach(s => {
        s.addEventListener('click', () => {
          selectedRating = parseInt(s.dataset.star) || 5;
          ratingInput.value = selectedRating;
          stars.forEach((st, idx) => {
            st.style.color = idx < selectedRating ? '#FFB400' : '#45495E';
          });
        });
      });
    }

    function renderReviews() {
      if (!reviewsContainer) return;
      let reviews = [];
      try {
        reviews = JSON.parse(localStorage.getItem(storageKey)) || [];
      } catch(e) {}

      if (reviews.length > 0) {
        reviewsContainer.innerHTML = '';
        reviews.forEach(r => {
          const card = document.createElement('div');
          card.className = 'pdp-review-card';
          card.style.cssText = 'background:#0E121F; border:1px solid rgba(255,255,255,0.08); border-radius:14px; padding:1.25rem;';
          
          let starsHtml = '';
          for (let i=0; i<5; i++) {
            starsHtml += i < r.rating ? '★' : '☆';
          }

          card.innerHTML = `
            <div style="display:flex; justify-content:space-between; margin-bottom:0.5rem;">
              <strong style="color:#FFF;">${r.author} <span style="color:#34C759; font-size:0.8rem; margin-left:6px;">✓ Verified Buyer</span></strong>
              <div style="color:#FFB400; font-size:1.1rem;">${starsHtml}</div>
            </div>
            <p style="color:#A0A5B5; margin:0 0 0.4rem; font-size:0.95rem; line-height:1.5;">${r.body}</p>
            <span style="font-size:0.75rem; color:#64748B;">${r.date}</span>
          `;
          reviewsContainer.appendChild(card);
        });

        if (tabBtnReviews) {
          const span = tabBtnReviews.querySelector('span');
          if (span) span.textContent = `REVIEWS (${reviews.length})`;
        }
      }
    }

    renderReviews();

    if (reviewForm) {
      reviewForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const author = document.getElementById('pdpReviewAuthor').value.trim();
        const email = document.getElementById('pdpReviewEmail').value.trim();
        const body = document.getElementById('pdpReviewBody').value.trim();

        if (!author || !body) return;

        const newReview = {
          author: author,
          rating: selectedRating,
          body: body,
          date: new Date().toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })
        };

        let reviews = [];
        try {
          reviews = JSON.parse(localStorage.getItem(storageKey)) || [];
        } catch(e) {}

        reviews.unshift(newReview);
        localStorage.setItem(storageKey, JSON.stringify(reviews));

        reviewForm.reset();
        document.getElementById('pdpReviewFormWrap').style.display = 'none';
        renderReviews();
        alert('Thank you! Your review has been submitted.');
      });
    }

  });
})();
